import unableToContinueRegistrationBlockDictionary from '@shared/ui/unable-to-continue-registration-block/i18n/ru/unable-to-continue-registration-block.dic.json';

export const unableToContinueRegistrationBlock = {
  UNABLE_TO_CONTINUE_REGISTRATION_BLOCK:
    unableToContinueRegistrationBlockDictionary,
};

export const unableToContinueRegistrationBlockNamespaces = Object.keys(
  unableToContinueRegistrationBlock
);
